import { combineReducers } from 'redux'
import authReducer from './authReducer'
import errorReducer from './errorReducer'

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
})


// WEBPACK FOOTER //
// ./src/reducers/index.js